module.exports = __webpack_public_path__ + "static/img/img_112.8e08975.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/production/images/img_112.webp
// module id = wxTT
// module chunks = 8